import React, { useState } from 'react';
import { IconCalendar } from '@tabler/icons-react';
interface DatePickerWidgetProps {
  question: string;
  onSubmit: (date: string) => void;
  onSkip: () => void;
}
export function DatePickerWidget({
  question,
  onSubmit,
  onSkip
}: DatePickerWidgetProps) {
  const [selectedDate, setSelectedDate] = useState('');
  const quickOptions = [{
    label: 'Oggi',
    days: 0
  }, {
    label: 'Domani',
    days: 1
  }, {
    label: 'Tra 3 giorni',
    days: 3
  }, {
    label: 'Tra una settimana',
    days: 7
  }];
  const handleQuickSelect = (days: number) => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    const formattedDate = date.toISOString().split('T')[0];
    setSelectedDate(formattedDate);
    onSubmit(formatDateForDisplay(formattedDate));
  };
  const handleDateInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const date = e.target.value;
    setSelectedDate(date);
    if (date) {
      onSubmit(formatDateForDisplay(date));
    }
  };
  const formatDateForDisplay = (dateString: string) => {
    const date = new Date(dateString + 'T00:00:00');
    return date.toLocaleDateString('it-IT', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };
  return <div className="mt-3 bg-white border border-yeppy-text border-opacity-15 rounded-2xl p-5 shadow-sm" data-id="element-422">
      <p className="font-rubik font-semibold text-base text-yeppy-text mb-4" data-id="element-423">
        {question}
      </p>

      {/* Quick options */}
      <div className="flex flex-wrap gap-2 mb-4" data-id="element-424">
        {quickOptions.map(option => <button key={option.label} onClick={() => handleQuickSelect(option.days)} className="px-4 py-2.5 rounded-xl font-poppins text-sm font-medium text-yeppy-text bg-white border border-yeppy-text border-opacity-15 transition-all active:scale-95" data-id="element-425">
            {option.label}
          </button>)}
      </div>

      {/* Divider */}
      <div className="relative my-4" data-id="element-426">
        <div className="absolute inset-0 flex items-center" data-id="element-427">
          <div className="w-full border-t border-yeppy-text border-opacity-10" data-id="element-428"></div>
        </div>
        <div className="relative flex justify-center" data-id="element-429">
          <span className="px-3 bg-white font-poppins text-xs text-yeppy-text text-opacity-50" data-id="element-430">
            oppure scegli una data
          </span>
        </div>
      </div>

      {/* Custom date input */}
      <div className="relative" data-id="element-431">
        <input type="date" value={selectedDate} onChange={handleDateInput} className="w-full pl-4 pr-12 py-3 rounded-xl font-poppins text-sm text-yeppy-text bg-white border border-yeppy-text border-opacity-15 focus:outline-none focus:border-yeppy-blue focus:border-opacity-50 transition-colors" data-id="element-432" />
        <IconCalendar className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 text-yeppy-text text-opacity-40 pointer-events-none" stroke={1.5} data-id="element-433" />
      </div>

      {/* Skip button */}
      <button onClick={onSkip} className="w-full mt-3 py-2.5 rounded-xl font-poppins text-sm font-medium text-yeppy-text text-opacity-60 transition-all" data-id="element-434">
        Salta questo passaggio
      </button>
    </div>;
}